import type { CSSProperties } from 'react';

/**
 * The Sonner Toaster's width (13-13, ISS-197). Sonner reads `--width` (default 356 px); the
 * approved mock's toasts are `min(560px, 100vw - 32px)`. Passed as the Toaster's `style`, which
 * Sonner spreads after its own default.
 */
export const TOASTER_STYLE = { '--width': 'min(560px, calc(100vw - 32px))' } as CSSProperties;
